import { AnimatePresence, motion } from 'framer-motion'
import { MouseEventHandler, useState } from 'react'

import { Social } from '../word/styled'
import { IconFacebook } from 'components/icons/facebook'
import { IconTwitter } from 'components/icons/twitter'
import { IconTelegram } from 'components/icons/telegram'
import { IconWhatsapp } from 'components/icons/whatsapp'
import { IconShare } from 'components/icons/share'
import { IconClose } from 'components/icons/close'
import { Container, Toggle } from './styled'
import { buildShareUrl } from './helpers'

export const Share = () => {
  const [isExpanded, setExpanded] = useState(false)

  const handleClick: MouseEventHandler<HTMLButtonElement> = evt => {
    if (
      typeof navigator !== 'undefined' &&
      typeof navigator.share === 'function'
    ) {
      navigator.share({
        url: window.location.href,
      })
    } else {
      setExpanded(v => !v)
    }
  }

  return (
    <Container layout>
      <AnimatePresence mode="popLayout">
        {isExpanded && (
          <Social
            layout
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <a
              target="_blank"
              href={buildShareUrl('facebook')}
              rel="noreferrer"
            >
              <IconFacebook />
            </a>
            <a target="_blank" rel="noreferrer" href={buildShareUrl('twitter')}>
              <IconTwitter />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={buildShareUrl('telegram')}
            >
              <IconTelegram />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={buildShareUrl('whatsapp')}
            >
              <IconWhatsapp />
            </a>
            <button onClick={() => setExpanded(false)}>
              <IconClose />
            </button>
          </Social>
        )}
      </AnimatePresence>

      <AnimatePresence mode="popLayout">
        {!isExpanded && (
          <Toggle
            layout
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleClick}
          >
            <IconShare />
          </Toggle>
        )}
      </AnimatePresence>
    </Container>
  )
}
